/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import RequestService from '../service/requestService';
import * as actionTypes from './actionTypes';

export const fetchingConsentDocumentsForSoP = () => {
  return {
    type: actionTypes.FETCHING_CONSENT_DOCUMENTS_FOR_SOP
  };
};

export const fetchedConsentDocumentsForSoP = (document) => {
  return {
    type: actionTypes.FETCHED_CONSENT_DOCUMENTS_FOR_SOP,
    payload: document
  };
};

export const fetchedConsentingOptInState4SoP = (consentingOptInOptOut) => {
  return {
    type: actionTypes.FETCHED_CONSENTING_OPTIN_STATE_FOR_SOP,
    payload: consentingOptInOptOut
  };
};

export const fetchConsentDocumentsForSoPError = (error) => {
  return {
    type: actionTypes.FETCH_CONSENT_DOCUMENTS_FOR_SOP_ERROR,
    payload: error
  };
};

export const clearConsentDocumentsForSoP = () => {
  return {
    type: actionTypes.CLEAR_CONSENT_DOCUMENTS_FOR_SOP
  };
};

export function fetchConsentingOptInState4SoP(consentId) {
  return (dispatch) => {
    dispatch(fetchingConsentDocumentsForSoP());
    return RequestService.getConsentingOptInState(consentId)
      .then((response) => {
        dispatch(fetchedConsentingOptInState4SoP(response.data));
      })
      .catch((error) => {
        dispatch(fetchConsentDocumentsForSoPError(error));
      });
  };
}

export function fetchConsentDocumentForSoP(consentGid) {
  return function (dispatch) {
    dispatch(fetchingConsentDocumentsForSoP());
    return RequestService.getConsentDocumentForParticipant(consentGid)
      .then((response) => {
        dispatch(fetchedConsentDocumentsForSoP(response));
      })
      .catch((error) => {
        dispatch(fetchConsentDocumentsForSoPError(error));
      });
  };
}
